<template>
  <div class="add-outlet">
    <v-modal :modalName="modalName" class="add-outlet__container">
      <template slot="header">
        <div class="add-outlet__container__header">
          <span class="add-outlet__container__header--title">Create outlet</span>
          <v-btn text large fab @click="closeOutlet" class="add-outlet__container__header--close">
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>
      <template slot="body">
        <div class="add-outlet__container__form">
          <label for="address">Address</label>
          <input
            name="address"
            type="text"
            placeholder="E.g. &quot;27 Albion St, Leeds LS1 5AT&quot;"
            v-model="outlet.address.address"
            :autofocus="'autofocus'"
            class="add-outlet__container__form__input"
          />
          <v-btn-toggle v-model="selectedCategory" class="add-outlet__container__form--group">
            <v-btn depressed>Eat</v-btn>
            <v-btn depressed>Shop</v-btn>
            <v-btn depressed>Do</v-btn>
          </v-btn-toggle>

          <v-row v-for="(branding, index) in outlet.branding" :key="index">
            <v-col>
              <v-img
                @click="changeImg(index)"
                :src="branding"
                :aspect-ratio="aspectRatio"
                class="img"
              ></v-img>
              <div
                style="display: flex; justify-content: center; z-index: 10; position: relative; top: -20px;"
              >
                <v-btn fab depressed small @click="removeImg(index)" class="accent remove">
                  <font-awesome-icon icon="times" class="remove-icon" />
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div style="display: flex; justify-content: center;">
                <v-btn
                  v-show="outlet.branding.length < 3"
                  @click="dialogs.cropper = !dialogs.cropper"
                  text
                >
                  <v-img
                    v-if="outlet.branding.length === 0"
                    src="@/assets/upload.png"
                    @click="cropper = !cropper"
                    class="add-outlet__container__form--icon"
                  />
                  <v-chip v-else class="px-7 accent">
                    <h1 style="margin-left: 220px;">Add {{ 3 - outlet.branding.length }} More</h1>
                  </v-chip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>
      <template slot="footer">
        <div class="add-outlet__container__footer">
          <v-btn text fab @click="createOutlet" class="check">
            <font-awesome-icon icon="check" />
          </v-btn>
        </div>
      </template>
    </v-modal>

    <v-dialog v-model="dialogs.cropper" fullscreen style="height: 100%;" fluid>
      <branding-cropper
        :uploadImg="uploadImg"
        @closeCropper="dialogs.cropper = !dialogs.cropper"
        @save="saveImg"
        @change="changeImg"
        :aspectRatio="aspectRatio"
        :branding="this.outlet.branding"
      ></branding-cropper>
    </v-dialog>

    <v-alert type="error" v-if="this.errors.address">Address required</v-alert>
    <v-alert type="error" v-if="this.errors.category">Category required</v-alert>
    <v-alert type="error" v-if="this.errors.branding">Branding required</v-alert>
  </div>
</template>

<script>
import brandingCropper from "@/components/outlets/brandingCropper";
import VModal from "@/components/VModal";
import axios from "axios";
import { mapActions, mapState } from "vuex";

const uuid = require("uuid/v4");

export default {
  components: {
    brandingCropper,
    VModal
  },

  data() {
    return {
      modalName: "outlet-modal",
      outlet: {
        address: {
          address: "",
          label: "Office"
        },
        location: {
          lat: "",
          lon: ""
        },
        geometry: [],
        type: "outlet",
        branding: [],
        category: [],
        parts: {},
        id: uuid()
      },

      selectedCategory: [],

      dialogs: {
        cropper: false
      },

      aspectRatio: 16 / 3,

      errors: {
        address: false,
        category: false,
        branding: false
      }
    };
  },

  methods: {
    ...mapActions({
      newOutlet: "outlets/createOutlet",
      toggleOutletModal: "ui/outletModalState"
    }),

    validInput() {
      if (!this.outlet.address.address) {
        this.errors.address = true;
        return true;
      } else this.errors.address = false;

      if (!this.outlet.category) {
        this.errors.category = true;
        return true;
      } else this.errors.category = false;
    },

    async generateAddress() {
      let geocoder = await new google.maps.Geocoder();
      await geocoder.geocode(
        { address: this.outlet.address.address },
        async (results, status) => {
          let lat = results[0].geometry.location.lat();
          let lon = results[0].geometry.location.lng();
          let town = results[0].address_components[3].short_name;
          let county = results[0].address_components[4].short_name;
          let postcode = results[0].address_components[0].short_name;

          this.outlet.address.address = results[0].formatted_address;
          this.outlet.location.lat = lat.toString();
          this.outlet.location.lon = lon.toString();
          this.outlet.geometry = this.getBoundingBox(lat, lon, 20);
          this.outlet.parts.town = town;
          this.outlet.parts.county = county;
          this.outlet.parts.postcode = postcode;
        }
      );

      console.log(this.outlet);
    },

    async createOutlet() {
      if (this.selectedCategory === 0) {
        this.outlet.category = "eat";
      } else if (this.selectedCategory === 1) {
        this.outlet.category = "shop";
      } else this.outlet.category = "do";
      const errors = await this.validInput();
      if (errors) {
        return;
      } else {
        await this.generateAddress();
        console.log(this.outlet);

        let id = uuid();
        let brandingArr = [];
        let attachments = {};

        for (let i = 0; i != this.outlet.branding.length; i++) {
          brandingArr.push(id);
          attachments[id] = {
            content_type: "image/jpeg",
            data: this.outlet.branding[i].replace("data:image/jpeg;base64,", "")
          };
        }

        let outletPayload = {
          type: this.outlet.type,
          name: this.merchant.name,
          categories: [this.outlet.category],
          location: this.outlet.location,
          geometry: this.outlet.geometry,
          merchant: {
            id: this.merchant.id,
            type: "merchant"
          },
          address: this.outlet.address,
          image: brandingArr,
          _attachments: attachments,
          id: this.outlet.id
        };

        console.log(outletPayload.geometry);
        console.log(outletPayload.location);
        console.log(outletPayload.address);

        this.newOutlet(outletPayload);
        this.closeOutlet();
      }
    },

    getBoundingBox(pLatitude, pLongitude, pDistanceInMeters) {
      var latRadian = (pLatitude * Math.PI) / 180;

      var degLatKm = 110.574235;
      var degLongKm = 110.572833 * Math.cos(latRadian);
      var deltaLat = pDistanceInMeters / 1000.0 / degLatKm;
      var deltaLong = pDistanceInMeters / 1000.0 / degLongKm;

      var topLat = pLatitude + deltaLat;
      var bottomLat = pLatitude - deltaLat;
      var leftLng = pLongitude - deltaLong;
      var rightLng = pLongitude + deltaLong;

      var boundingBox = [
        {
          lat: topLat.toString(),
          lon: leftLng.toString()
        },
        {
          lat: topLat.toString(),
          lon: rightLng.toString()
        },
        {
          lat: bottomLat.toString(),
          lon: leftLng.toString()
        },
        {
          lat: bottomLat.toString(),
          lon: rightLng.toString()
        }
      ];

      return boundingBox;
    },

    closeOutlet() {
      this.toggleOutletModal();
    },

    uploadImg() {
      this.$emit("uploadImg");
    },

    changeImg(val) {
      this.dialogs.cropper = true;
      this.outlet.branding[0] = val;
    },

    removeImg(index) {
      this.outlet.branding.splice(index, 1);
    },

    saveImg(val) {
      if (this.outlet.branding.length < 3) {
        this.outlet.branding.push(val);
      }
    }
  },

  computed: {
    ...mapState({ merchants: state => state.merchants }),

    merchant() {
      return this.merchants.items[0];
    }
  }
};
</script>

<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.add-outlet
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  backdrop-filter: blur(4px)
  background: rgba($c-black, .3)
  z-index: 100

  &__container
    width: 400px
    height: 450px
    transform: scale(.8)
    border-radius: 15px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)

    @include for-size(phone-only)
      transform: scale(.8)

    &__header
      &--title
        position: relative
        left: 130px

      &--close
        position: relative
        top: -20px
        left: 220px

    &__form
      height: 250px

      &__input
        display: flex
        flex-flow: column
        position: relative
        margin-bottom: 30px
        outline: none    
        transition: all .3s

        &:hover, &:focus
          border: 1px solid $dark-purple  

      &--group
        position: relative
        left: 80px
        width: 150px
        border-radius: 30px

      &--icon
        margin: 20px auto
        width: 50px

      &--logo
        position: relative
        left: 40%
        width: 100px
        margin-top: 20px

    &__footer
      position: relative
      display: flex
      justify-content: center
      height: 100px
      padding: 30px

    .check
      padding: 0
      margin: 0

.modal-bounce-enter-active, .modal-bounce-leave-active
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.15)
    
.modal-bounce-enter, .modal-bounce-leave-to
  transform: scale(1.3)


.img
  width: 50%
  margin: 0 auto
  border: 3px solid #3f51b5

.remove
  margin: 0 auto
  z-index: 10

.remove-icon
  color: #fff

</style>
